import React, {
    useEffect,
    useCallback,
    useRef,
    Fragment,
} from 'react';
import { useAlert } from '../../../utilities/hooks';
import { userLogout } from '../../../actions/userActions';
import { alertType } from '../../Common/UniAlert/context';
import { getUserPreference } from '../../../utilities/common';
import { useTranslation } from 'react-i18next';

const DEFAULT_TIMEOUT = 10000

const SessionTimeout = (props) => {
    const {timeout} = props
    const alertDialog = useAlert();
    const {t} = useTranslation('dialog');

    const events = ['click', 'load', 'scroll']

    let startTimerInterval = useRef();
    let userPref = getUserPreference();

    const timeChecker = () => {
        startTimerInterval.current = setTimeout(() => {
            userPref = getUserPreference();
            if(userPref.authToken){
                sessionInactive()
            }
        }, timeout || DEFAULT_TIMEOUT)
    }

    const resetTimer = useCallback(() => {
        clearTimeout(startTimerInterval.current)
        timeChecker()
    }, [userPref])

    const sessionInactive = () => {
        clearTimeout(startTimerInterval.current)
        alertDialog.addAlertDialog(
            t('session_timeout_title'), 
            t('session_timeout_message'), 
            alertType.INFO,
            null, null, undefined, true, false)
        alertDialog.addActionButton(
            t('common:logout'), 
            ()=>{
                timeChecker()
                userLogout()
            },
            "primary")
        alertDialog.showAlert();
    }

    useEffect(() => {
        events.forEach((event) => {
            window.addEventListener(event, resetTimer);
        })
        timeChecker()

        return ()=>{
            clearTimeout(startTimerInterval.current)
        }
    }, [])

    return <Fragment />;
};

export default SessionTimeout;